module.exports = __webpack_public_path__ + "img/green_056.3db344b7.png";